<template>
    <v-dialog v-model="modal" width="800px" max-width="100%">
        <v-card v-if="offer" width="800px" max-width="100%" class="pa-md-3">
            <v-card-title>
                <span class="text-h6">
                    {{ offer.serviceName }}
                </span>
                <v-icon class="v-card-close ma-4" @click="modal = false">mdi-close</v-icon>
            </v-card-title>
            <v-card-text class="text-black">
                <v-tabs v-model="tab">
                    <v-tab>
                        {{ $t('description') }}
                    </v-tab>
                </v-tabs>
                <v-window v-model="tab">
                    <v-window-item>
                        <v-row no-gutters>
                            <template
                                v-if="
                                    (info.images && info.images.length) ||
                                    info.fullDescription ||
                                    info.shortDescription ||
                                    (info.comments && info.comments.length)
                                "
                            >
                                <v-col cols="12" md="4">
                                    <v-carousel
                                        height="170px"
                                        hide-delimiters
                                        :show-arrows="info.images && info.images.length > 1 ? 'hover' : false"
                                    >
                                        <v-carousel-item v-for="(image, imageIndex) in info.images" :key="imageIndex">
                                            <v-img :src="$filters.imageUrl(image.url, 300)" cover />
                                        </v-carousel-item>
                                    </v-carousel>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <div v-if="info.duration" class="d-flex align-center ml-4">
                                        <v-icon start size="small">mdi-timer-outline</v-icon>
                                        <strong class="text-black me-1">
                                            {{ `${info.duration} ${$t('day', info.duration)}` }}
                                        </strong>
                                    </div>
                                    <template v-if="info.shortDescription">
                                        <div class="ml-4">
                                            <div class="font-weight-bold mt-2">
                                                {{ $t(`description_type.short`) }}
                                            </div>
                                            <div v-html="info.shortDescription" />
                                        </div>
                                    </template>
                                    <template v-if="info.fullDescription">
                                        <div class="ml-4">
                                            <div class="font-weight-bold mt-2">
                                                {{ $t(`description_type.general`) }}
                                            </div>
                                            <div v-html="info.fullDescription" />
                                        </div>
                                    </template>
                                    <template v-if="info.comments && info.comments.length">
                                        <div class="ml-4">
                                            <strong> {{ $t('comments') }} </strong><br />
                                            <div v-for="(comment, commentIndex) in info.comments" :key="commentIndex">
                                                {{ comment.title }}: {{ comment.description }}
                                            </div>
                                        </div>
                                    </template>
                                </v-col>
                            </template>
                            <v-col v-else cols="12" class="d-flex align-center flex-column justify-center">
                                <div class="text-center text-caption text--secondary">
                                    {{ $t('no_data') }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-window-item>
                </v-window>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_SIMPLE_TOUR_OFFER_INFO_MODAL} from '@/utils/event-bus'

    //TODO Need refactoring with other products
    @Component
    export class SimpleTourOfferInfoModal extends Vue {
        offer = null
        modal = false
        tab = null
        info = null

        mounted() {
            EventBus.$on(SHOW_SIMPLE_TOUR_OFFER_INFO_MODAL, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_SIMPLE_TOUR_OFFER_INFO_MODAL, this.showModal)
        }

        showModal({offer, info}) {
            this.offer = offer
            this.info = info
            this.modal = true
        }
    }

    export default SimpleTourOfferInfoModal
</script>
